import { fetchWithAuth } from "./http";
import { Customer, CustomerUpdate, CustomerStatus } from "../features/customers/domain/types";

export const getAll = (token: string) =>
    fetchWithAuth<Customer[]>('/admin/customers', token);

export const getById = (customerId: string, token: string) =>
    fetchWithAuth<Customer>(`/admin/customers/${customerId}`, token);

export const create = (data: { customer_name: string; contact_email?: string }, token: string) =>
    fetchWithAuth<Customer>('/admin/create-customer', token, {
        method: 'POST',
        body: JSON.stringify(data),
    });

export const update = (customerId: string, data: CustomerUpdate, token: string) =>
    fetchWithAuth<Customer>(`/admin/customers/${customerId}`, token, {
        method: 'PATCH',
        body: JSON.stringify(data),
    });

export const getStatus = (customerId: string, token: string) =>
    fetchWithAuth<CustomerStatus>(`/gating/status?customer_id=${customerId}`, token);

export const deleteCustomer = (customerId: string, customerName: string, token: string) =>
    fetchWithAuth<{
        customer_id: string;
        customer_name: string;
        projects_deleted: number;
        model_runs_deleted: number;
        users_deleted: number;
        message: string;
    }>(`/admin/customers/${customerId}`, token, {
        method: 'DELETE',
        body: JSON.stringify({ customer_name_confirmation: customerName }),
    });
